import { apiInstance } from 'api/utils';

export interface ResearchRelationsRequest {
  research_items: number[];
}

export default {
  getResearchRelations: (data: ResearchRelationsRequest) =>
    apiInstance.request({
      method: 'POST',
      url: '/research-relations',
      data
    }),
  updateResearchRelations: (data: any) =>
    apiInstance.request({
      method: 'POST',
      url: '/update-research-relations',
      data
    }),
  deleteResearchRelations: (data: any) =>
    apiInstance.request({
      method: 'DELETE',
      url: '/update-research-relations',
      data
    }),
  createResearchItem: (data: any) =>
    apiInstance.request({
      method: 'POST',
      url: '/research-item',
      data
    }),
  deleteResearchItem: (data: any) =>
    apiInstance.request({
      method: 'delete',
      url: '/research-item',
      data
    }),
  getResearchItems: () =>
    apiInstance.request({
      method: 'GET',
      url: '/research-items'
    }),
  getResearchItemPastPerformance: ({ id, data }: any) =>
    apiInstance.request({
      method: 'POST',
      url: `/research-item/${id}/past-performance`,
      data
    }),
  getResearchItemAssetAllocation: (id: number) =>
    apiInstance.request({
      method: 'GET',
      url: `/research-item/${id}/asset-allocation`
    }),
  getResearchItemCountryBreakdown: (id: number) =>
    apiInstance.request({
      method: 'GET',
      url: `/research-item/${id}/country-breakdown`
    }),
  getResearchItemRegionalBreakdown: (id: number) =>
    apiInstance.request({
      method: 'GET',
      url: `/research-item/${id}/regional-breakdown`
    }),
  getResearchItemSectorBreakdown: (id: number) =>
    apiInstance.request({
      method: 'GET',
      url: `/research-item/${id}/sector-breakdown`
    }),
  downloadReport: (data: any) =>
    apiInstance.request({
      method: 'POST',
      url: `/research-item/download`,
      responseType: 'blob',
      data
    }),
  getResearchItemRiskRatings: (id: number) =>
    apiInstance.request({
      method: 'GET',
      url: `/research-item/${id}/risk-ratings`
    }),
  updateModelPortfolioCharge: (id: number, relationId: number, charges: any) =>
    apiInstance.request({
      method: 'POST',
      url: `research-item/${id}/charges`,
      data: {
        id: relationId,
        charges
      }
    })
};
